import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, Select, MenuItem, Button, Box, Typography, TextField, Skeleton } from "@mui/material";
import { useYojanaSelect } from "../../API_Master/FetchAPI";
import { useEffect, useState } from "react";
import { useEditGramYojanaMemberDetail } from "../../API_Master/MutateAPI";
import Cookies from "js-cookie";
import { notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";

const EditYojanaMemberDetail = ({ open, onClose, selectedEditMemberDetail, refetchMemberList }) => {
  const [amountDropDownData, setAmountDropDownData] = useState([]);
  const [amount, setAmount] = useState("");

  console.log("selejsldfsldfjsdklf", selectedEditMemberDetail, open);

  const { data: YojanaData = [], isFetching } = useYojanaSelect(open);
  const { mutate: editGramYojanaMemberDetail, isPending: inserting } = useEditGramYojanaMemberDetail();

  const isManualAmount = selectedEditMemberDetail?.IsAmountEnterByUser;

  useEffect(() => {
    if (YojanaData?.length > 0) {
      const YojanaAmountDetail = YojanaData?.find((yojana) => yojana?.GramYojnaID?.toString() === selectedEditMemberDetail?.GramYojnaID?.toString())?.AmountDetails;
      setAmountDropDownData(YojanaAmountDetail);
    }
  }, [YojanaData, open]);

  useEffect(() => {
    if (open && selectedEditMemberDetail) {
      setAmount(selectedEditMemberDetail?.Amount ?? "");
    }
  }, [open, selectedEditMemberDetail]);

  const handleSubmit = () => {
    const selectedAmountDetailID = amountDropDownData?.find((amountDetail) => amountDetail?.Amount === amount)?.GramYojnaAmountDetailID || "";

    const payload = {
      GramYojnaMemberID: selectedEditMemberDetail?.GramYojnaMemberID,
      GramYojnaID: selectedEditMemberDetail?.GramYojnaID,
      GramYojnaName: selectedEditMemberDetail?.GramYojnaName,
      GramYojnaAmountDetailID: selectedAmountDetailID,
      Amount: amount,
      TotalAmount: selectedEditMemberDetail?.TimePeriod && selectedEditMemberDetail?.TimePeriod != "1" ? parseInt(amount) * parseInt(selectedEditMemberDetail?.TimePeriod) : amount,
      UpdatedByUserID: Cookies.get("Mukesh_Patel_UserID") || "",
    };

    editGramYojanaMemberDetail(payload, {
      onSuccess: (res) => {
        if (res?.status === true) {
          notifySuccess("Successfully Updated", false);
          onClose();
          refetchMemberList();
        } else {
          notifyError(res?.message ? res.message : "Data Not Updated", false);
        }
      },
      onError: (err) => {
        const errorMessage = err?.message || "Failed to assign system";
        console.error(err);
        notifyError(errorMessage || "Something went wrong", false);
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Edit Amount</DialogTitle>

      {isFetching || !selectedEditMemberDetail ? (
        <EditYojanaMemberDetailShimmer open={open} />
      ) : (
        <>
          {" "}
          <DialogContent>
            {/* Member Name */}
            <Box
              sx={{
                mb: 2,
                p: 1.5,
                borderRadius: "8px",
                backgroundColor: "#f4f6f8",
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Yojana Name
              </Typography>
              <Typography fontWeight={500}>{selectedEditMemberDetail?.GramYojnaName}</Typography>
            </Box>
            <Box
              sx={{
                mb: 2,
                p: 1.5,
                borderRadius: "8px",
                backgroundColor: "#f4f6f8",
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                Member Name
              </Typography>
              <Typography fontWeight={500}>{selectedEditMemberDetail?.MemberName}</Typography>
            </Box>

            {/* Amount Select */}
            <FormControl fullWidth size="small">
              <Typography variant="caption" color="text.secondary" mb={0.5}>
                Amount
              </Typography>

              {isManualAmount ? (
                /* 🔹 TEXT FIELD */
                <TextField
                  size="small"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              ) : (
                /* 🔹 SELECT FIELD */
                <Select
                  displayEmpty
                  value={amount || ""}
                  onChange={(e) => {
                    setAmount(e.target.value);
                  }}
                  sx={{
                    borderRadius: "8px",
                    "&.Mui-disabled": {
                      backgroundColor: "#e4e2e27c",
                      color: "#555",
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <em>Select Amount</em>
                  </MenuItem>

                  {amountDropDownData?.map((amt) => (
                    <MenuItem key={amt.Amount} value={amt.Amount}>
                      ₹ {amt.Amount}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FormControl>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={onClose} color="inherit">
              Cancel
            </Button>
            <Button variant="contained" disabled={!amount || Number(amount) <= 0} onClick={handleSubmit}>
              Save
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default EditYojanaMemberDetail;

const EditYojanaMemberDetailShimmer = ({ open }) => {
  return (
    <>
      <DialogTitle>
        <Skeleton width={120} height={28} />
      </DialogTitle>

      <DialogContent>
        {/* Yojana Name Card */}
        <Box
          sx={{
            mb: 2,
            p: 1.5,
            borderRadius: "8px",
            backgroundColor: "#f4f6f8",
          }}
        >
          <Skeleton width={80} height={14} />
          <Skeleton width="70%" height={22} />
        </Box>

        {/* Member Name Card */}
        <Box
          sx={{
            mb: 2,
            p: 1.5,
            borderRadius: "8px",
            backgroundColor: "#f4f6f8",
          }}
        >
          <Skeleton width={90} height={14} />
          <Skeleton width="60%" height={22} />
        </Box>

        {/* Amount Label */}
        <Skeleton width={60} height={14} sx={{ mb: 1 }} />

        {/* Amount Field */}
        <Skeleton variant="rounded" height={40} sx={{ borderRadius: "8px" }} />

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 3,
          }}
        >
          <Skeleton variant="rounded" width={80} height={36} />
          <Skeleton variant="rounded" width={90} height={36} />
        </Box>
      </DialogContent>
    </>
  );
};
